const checklist = [
  'Hardware Maintenance',
  'Laptop & Desktop Support',
  'Network Assistance',
  'Printer Support',
  'Troubleshooting',
  'Preventive Maintenance',
];

const statusItems = [
  { label: 'Network', status: 'Online', color: '#22c55e' },
  { label: 'Computers', status: 'Active', color: '#22c55e' },
  { label: 'Printers', status: 'Connected', color: '#22c55e' },
  { label: 'Support', status: 'Available', color: '#22c55e' },
];

export default function AMCSupport() {
  return (
    <section id="amc" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 dot-pattern opacity-30"></div>

      <div className="max-w-site mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full animate-on-scroll">
            <span className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">AMC &amp; IT Support</span>
            <h2 className="mt-4 font-heading text-[36px] md:text-[48px] font-bold text-foreground-950 tracking-[-0.02em] leading-[1.14]">
              Less downtime.<br />
              <span style={{ color: '#0167F8' }}>More business.</span>
            </h2>
            <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed max-w-[520px]">
              Keep your technology running smoothly with reliable maintenance and responsive IT support from TechBridge.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {checklist.map((item) => (
                <div key={item} className="flex items-center gap-3 group">
                  <div className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 bg-primary-50 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-check-line text-primary-500 group-hover:text-white text-xs transition-colors duration-300"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="mt-8 whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-300 cursor-pointer group hover:shadow-xl hover:shadow-primary-500/20 hover:-translate-y-0.5"
              style={{ backgroundColor: '#0167F8', color: '#FFFFFF', padding: '14px 28px' }}
            >
              Talk to Our Team
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
            </a>
          </div>

          <div className="flex-1 w-full flex justify-center animate-on-scroll">
            <div className="relative w-full max-w-[440px]">
              <div className="bg-white/70 backdrop-blur-xl border border-background-200/80 rounded-2xl p-6 md:p-8 relative z-10 shadow-lg shadow-background-200/50">
                <div className="flex items-center gap-2 mb-6">
                  <span className="w-2 h-2 rounded-full bg-green-500 relative">
                    <span className="absolute inset-[-3px] rounded-full bg-green-500/30 animate-ping"></span>
                  </span>
                  <span className="font-label text-xs uppercase tracking-[0.15em] text-foreground-500">System Status</span>
                </div>

                <div className="space-y-4">
                  {statusItems.map((item) => (
                    <div key={item.label} className="flex items-center justify-between py-3 border-b border-background-100 last:border-0">
                      <span className="text-sm text-foreground-700">{item.label}</span>
                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full relative" style={{ backgroundColor: item.color }}>
                          <span className="absolute inset-[-3px] rounded-full animate-ping" style={{ backgroundColor: item.color, opacity: 0.3 }}></span>
                        </span>
                        <span className="font-label text-xs font-semibold text-foreground-950">{item.status}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Decorative floating device indicators */}
              <div className="absolute -top-4 -right-4 w-12 h-12 rounded-xl bg-white/80 backdrop-blur-sm border border-background-200 flex items-center justify-center z-20 shadow-sm hover:shadow-md transition-shadow duration-300">
                <i className="ri-macbook-line text-primary-500 text-lg"></i>
              </div>
              <div className="absolute -bottom-3 -left-3 w-10 h-10 rounded-xl bg-white/80 backdrop-blur-sm border border-background-200 flex items-center justify-center z-20 shadow-sm hover:shadow-md transition-shadow duration-300">
                <i className="ri-router-line text-primary-500"></i>
              </div>
              <div className="absolute top-1/2 -right-6 w-8 h-8 rounded-lg bg-white/80 backdrop-blur-sm border border-background-200 flex items-center justify-center z-20 shadow-sm hover:shadow-md transition-shadow duration-300">
                <i className="ri-printer-line text-primary-500 text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}